import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

import { App } from './app/App';
import { AppProviders } from './app/AppProviders';
import { ConfigurationGuard } from './app/ConfigurationGuard';

const container = document.getElementById('root');

if (container === null) {
    throw new Error('Het root-element ontbreekt in index.html.');
}

createRoot(container).render(
    <StrictMode>
        {/*
            Outside the providers: if the API origin in this bundle cannot work
            on this host, there is nothing for a query client to talk to and the
            reader gets one honest screen instead of twenty empty ones.
        */}
        <ConfigurationGuard>
            <AppProviders>
                <App />
            </AppProviders>
        </ConfigurationGuard>
    </StrictMode>,
);
